// Characters used for scrambling
const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

// Buttons

function scrambleHover(el) {
    const original = el.textContent;
    const length = original.length;

    // start index for scrambling (last 50%)
    const startIndex = Math.floor(length * 0.5);

    let frame = null;

    el.setAttribute('data-scramble', original);

    el.addEventListener('mouseenter', () => {
        let iteration = 0;

        cancelAnimationFrame(frame);

        function animate() {
            let output = '';

            for (let i = 0; i < length; i++) {
                if (i < startIndex) {
                    // keep first half stable
                    output += original[i];
                } else {
                    // scramble second half progressively
                    if (i < startIndex + iteration) {
                        output += original[i];
                    } else {
                        output += CHARS[Math.floor(Math.random() * CHARS.length)];
                    }
                }
            }

            el.setAttribute('data-scramble', output);

            iteration += 0.5;

            if (startIndex + iteration < length) {
                frame = requestAnimationFrame(animate);
            } else {
                el.setAttribute('data-scramble', original);
            }
        }

        animate();
    });

    el.addEventListener('mouseleave', () => {
        cancelAnimationFrame(frame);
        el.setAttribute('data-scramble', original);
    });
}

document.querySelectorAll('.btn span').forEach(scrambleHover);

function scrambleOverlay(el, finalText, duration = 500) {
    let start = null;
    const length = finalText.length;

    el.classList.add('is-scrambling');

    function frame(ts) {
        if (!start) start = ts;
        const progress = (ts - start) / duration;

        let output = '';

        for (let i = 0; i < length; i++) {
            const wave = i / length;

            if (progress > wave) {
                if (progress < wave + 0.15) {
                    output += CHARS[Math.floor(Math.random() * CHARS.length)];
                } else {
                    output += finalText[i];
                }
            } else {
                output += ' ';
            }
        }

        el.setAttribute('data-scramble', output);

        if (progress < 1) {
            requestAnimationFrame(frame);
        } else {
            el.setAttribute('data-scramble', finalText);
            el.classList.remove('is-scrambling');
        }
    }

    requestAnimationFrame(frame);
}

// apply stagger
document.querySelectorAll('.main-title .line').forEach((el, i) => {
    const text = el.textContent;

    setTimeout(() => {
        scrambleOverlay(el, text, 600);
    }, i * 250);
});
let isTriggered = false;


/* ===============================  Title divider  =============================== */
document.addEventListener('DOMContentLoaded', function () {

    function measureTextWidth(el) {
        const styles = window.getComputedStyle(el);

        const lines = el.innerHTML
            .replace(/<br\s*\/?>/gi, '\n')
            .split('\n');

        let maxWidth = 0;

        lines.forEach(line => {
            const clone = document.createElement('span');

            clone.textContent = line.trim();
            clone.style.position = 'absolute';
            clone.style.visibility = 'hidden';
            clone.style.whiteSpace = 'nowrap';
            clone.style.left = '-9999px';
            clone.style.top = '-9999px';

            clone.style.fontFamily = styles.fontFamily;
            clone.style.fontSize = styles.fontSize;
            clone.style.fontWeight = styles.fontWeight;
            clone.style.letterSpacing = styles.letterSpacing;
            clone.style.textTransform = styles.textTransform;
            clone.style.lineHeight = styles.lineHeight;

            document.body.appendChild(clone);

            const width = clone.getBoundingClientRect().width;
            maxWidth = Math.max(maxWidth, width);

            clone.remove();
        });

        return Math.ceil(maxWidth);
    }

    function createDivider(width) {
        const startX = 120;
        const rightWidth = Math.max(width - startX, 20);
        const endX = startX + rightWidth;

        return `
      <svg class="divider" width="${endX}" height="7" viewBox="0 0 ${endX} 7" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0H76L70 7H0L6 0Z" fill="currentColor"/>
        <path d="M80 7H74L80 0H86L80 7Z" fill="currentColor"/>
        <path d="M90 7H84L90 0H96L90 7Z" fill="currentColor"/>
        <path d="M100 7H94L100 0H106L100 7Z" fill="currentColor"/>
        <path d="M110 7H104L110 0H116L110 7Z" fill="currentColor"/>
        <path d="M${startX} 0H${endX}L${endX - 2.6} 3H${startX - 2.5}L${startX} 0Z" fill="currentColor"/>
      </svg>
    `;
    }

    function initDividers() {
        document.querySelectorAll('.title').forEach(title => {
            if (title.querySelector('.divider')) return;

            const h = title.querySelector('h1') || title.querySelector('h2');
            if (!h) return;

            const width = measureTextWidth(h);
            h.insertAdjacentHTML('afterend', createDivider(width));
        });
    }

    function refreshDividers() {
        document.querySelectorAll('.divider').forEach(el => el.remove());
        initDividers();
    }

    requestAnimationFrame(initDividers);

    let t;
    window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(refreshDividers, 150);
    });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refreshDividers);
    }
});

/* ===============================  Cut Frame  =============================== */
class CutFrame {
    constructor(selector = '.js-cut-frame') {
        this.elements = document.querySelectorAll(selector);
        this.init();
    }

    init() {
        this.updateAll();
        window.addEventListener('resize', () => this.updateAll());
    }

    updateAll() {
        this.elements.forEach(el => this.update(el));
    }

    update(el) {
        const svg = el.querySelector('svg');
        if (!svg) return;

        const paths = svg.querySelectorAll('path');
        if (!paths.length) return;

        const styles = getComputedStyle(el);

        const cutX = parseFloat(styles.getPropertyValue('--cut-x')) || 0;
        const cutY = parseFloat(styles.getPropertyValue('--cut-y')) || 0;

        const w = el.offsetWidth;
        const h = el.offsetHeight;

        const d = `
      M0 0
      H${w}
      V${h - cutY}
      L${w - cutX} ${h}
      H0
      Z
    `;

        svg.setAttribute('viewBox', `0 0 ${w} ${h}`);

        paths.forEach(path => {
            path.setAttribute('d', d);
        });

        const length = paths[0].getTotalLength();

        const lines = svg.querySelectorAll('.line');

        lines.forEach((line, i) => {
            line.style.strokeDasharray = length;
            line.style.strokeDashoffset = i === 0 ? length : -length;
        });

        if (el._cutFrameMouseEnter) {
            el.removeEventListener('mouseenter', el._cutFrameMouseEnter);
        }

        if (el._cutFrameMouseLeave) {
            el.removeEventListener('mouseleave', el._cutFrameMouseLeave);
        }

        el._cutFrameMouseEnter = () => {
            lines.forEach(line => {
                line.style.transition = 'stroke-dashoffset 2.6s cubic-bezier(0.25,1,0.5,1)';
                line.style.strokeDashoffset = 0;
            });
        };

        el._cutFrameMouseLeave = () => {
            lines.forEach((line, i) => {
                line.style.transition = 'none';
                line.style.strokeDashoffset = i === 0 ? length : -length;
            });
        };

        // Rebind handlers so resize updates still use the latest line geometry.
        el.addEventListener('mouseenter', el._cutFrameMouseEnter);
        el.addEventListener('mouseleave', el._cutFrameMouseLeave);
    }
}

// INIT
document.addEventListener('DOMContentLoaded', () => {
    new CutFrame();
});


// Elements Animation
/* ===============================  Preloader page  =============================== */

AOS.init();
